import { __awaiter } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';
import { AssistantClient } from './assistantClient.js';

const EMPTY_CLIENT = {
    getCookie: () => __awaiter(void 0, void 0, void 0, function* () { }),
    fetchInitSessionInfo: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            resolve({ sessionId: '', zeroStateExperienceFlag: true, chatHistory: [] });
        });
    }),
    submitFeedback: () => __awaiter(void 0, void 0, void 0, function* () { }),
};
const ClientContext = createContext(EMPTY_CLIENT);
const useClient = () => useContext(ClientContext);
function ClientProvider(props) {
    const client = useMemo(() => {
        return new AssistantClient(props.endpoint, props.initData);
    }, [props.endpoint, props.initData]);
    return (jsx(ClientContext.Provider, { value: client, children: props.children }));
}

export { ClientProvider, EMPTY_CLIENT, useClient };
